import React, { ComponentProps, FunctionComponent } from "react";

const DialPadIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M4 2C4 3.10457 3.10457 4 2 4C0.895431 4 0 3.10457 0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2Z",
    }),
    React.createElement("path", {
      d: "M9 2C9 3.10457 8.10457 4 7 4C5.89543 4 5 3.10457 5 2C5 0.895431 5.89543 0 7 0C8.10457 0 9 0.895431 9 2Z",
    }),
    React.createElement("path", {
      d: "M14 2C14 3.10457 13.1046 4 12 4C10.8954 4 10 3.10457 10 2C10 0.895431 10.8954 0 12 0C13.1046 0 14 0.895431 14 2Z",
    }),
    React.createElement("path", {
      d: "M4 7C4 8.10457 3.10457 9 2 9C0.895431 9 0 8.10457 0 7C0 5.89543 0.895431 5 2 5C3.10457 5 4 5.89543 4 7Z",
    }),
    React.createElement("path", {
      d: "M9 7C9 8.10457 8.10457 9 7 9C5.89543 9 5 8.10457 5 7C5 5.89543 5.89543 5 7 5C8.10457 5 9 5.89543 9 7Z",
    }),
    React.createElement("path", {
      d: "M14 7C14 8.10457 13.1046 9 12 9C10.8954 9 10 8.10457 10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7Z",
    }),
    React.createElement("path", {
      d: "M4 12C4 13.1046 3.10457 14 2 14C0.895431 14 0 13.1046 0 12C0 10.8954 0.895431 10 2 10C3.10457 10 4 10.8954 4 12Z",
    }),
    React.createElement("path", {
      d: "M9 12C9 13.1046 8.10457 14 7 14C5.89543 14 5 13.1046 5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12Z",
    }),
    React.createElement("path", {
      d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
    })
  );
};

const ForwardRef = React.forwardRef(DialPadIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
